/**
 * AstorAvatar — small circular Astor mark used inline next to "next-step"
 * suggestions and in banner headers. Mint teal background with sparkle icon.
 *
 * Sized via `size` prop (default 20) to match the surrounding text scale.
 */

'use client';

import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Box, baseColors } from '@ops-matrix/design-system-ui';
import type { ReactElement } from 'react';

export interface AstorAvatarProps {
  size?: number;
  pulse?: boolean;
}

export function AstorAvatar({ size = 20, pulse }: AstorAvatarProps): ReactElement {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        bgcolor: baseColors.teal[500],
        color: baseColors.neutral[0],
        boxShadow: pulse ? `0 0 0 4px ${baseColors.teal[100]}` : 'none',
        transition: 'box-shadow 200ms ease',
      }}
    >
      <AutoAwesomeIcon sx={{ fontSize: size * 0.6 }} />
    </Box>
  );
}
